// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3m787","clinicsSelect":"TableHeading_clinicsSelect__2CtBq"};